module.exports = __webpack_public_path__ + "img/l2moon.020bf934.svg";